import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { addToFavourites } from "../../../services/meals";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

export default function Product({
  product,
  finalPrice,
  setFinalPrice,
  cart,
  setCart,
  user,
  showMessage,
  setShowMessage,
  isCombo,
}) {
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);
  const [amount, setAmount] = useState(product?.amount || 1);
  const [amountExpression, setAmountExpression] = useState("+");
  const navigate = useNavigate();

  const [priceBGN, setPriceBGN] = useState(null);

  // Two cart lines are the same item only when the meal, its extras and the
  // chosen weight all match - different grammages have different prices.
  const cartItemKey = (item) =>
    `${item?.id}_${JSON.stringify(item?.added)}_${JSON.stringify(
      item?.removed,
    )}_${item?.chosenWeight ?? ""}`;

  useEffect(() => {
    if (!product?.price) return;

    setPriceBGN((Number(product?.price) * 1.95583)?.toFixed(2));
  }, [product]);

  return (
    <div className="product">
      <div className="left">
        {window.screen.width > 767 && (
          <div
            className="product-image"
            onClick={() =>
              isCombo
                ? navigate(`/menu/combos/${product.id}`)
                : navigate(`/menu/product/${product.id}`)
            }
          >
            {product?.images?.length > 0 ? (
              <img
                src={product?.images?.length > 0 ? product?.images[0]?.url : ""}
                alt=""
              ></img>
            ) : (
              <img
                src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
                alt=""
              ></img>
            )}
          </div>
        )}
        <div className="product-info">
          <div className="product-name">
            <div className="left">
              <div
                className="name"
                onClick={() =>
                  isCombo
                    ? navigate(`/menu/combos/${product.id}`)
                    : navigate(`/menu/product/${product.id}`)
                }
              >
                <p>
                  {product?.name}{" "}
                  {product?.chosenWeight != null && (
                    <span>{product.chosenWeight}г</span>
                  )}
                </p>
              </div>
            </div>
            {window.screen.width <= 767 && (
              <div className="right">
                {!user?.isGuest && (
                  <div
                    className="icon"
                    onClick={() => {
                      addToFavourites(product.id, cookie.access_token).then(
                        () => setShowMessage(true),
                      );
                    }}
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 19.5135C10.8887 19.5135 10.7775 19.4848 10.6778 19.4272C10.5695 19.3647 7.99692 17.8711 5.38744 15.6204C3.84082 14.2866 2.60625 12.9636 1.71808 11.6883C0.568758 10.038 -0.00921316 8.45065 0.000111035 6.97025C0.0110251 5.24764 0.628012 3.62763 1.73755 2.40861C2.86582 1.16905 4.37153 0.48645 5.9774 0.48645C8.03547 0.48645 9.91711 1.6393 11 3.46555C12.083 1.63934 13.9646 0.48645 16.0227 0.48645C17.5398 0.48645 18.9873 1.10236 20.0987 2.22075C21.3183 3.44807 22.0112 5.18219 21.9999 6.97841C21.9905 8.45623 21.4017 10.0412 20.2499 11.6892C19.359 12.9638 18.1261 14.2862 16.5855 15.6197C13.9856 17.8701 11.4315 19.3637 11.324 19.4262C11.2239 19.4844 11.1119 19.5135 11 19.5135Z"
                        fill="#FEAC7A"
                      />
                    </svg>
                  </div>
                )}
                <div
                  className="icon"
                  onClick={() => {
                    setCart(
                      cart.filter(
                        (i) => cartItemKey(i) !== cartItemKey(product),
                      ),
                    );
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.833 5.83337C15.612 5.83337 15.4 5.92117 15.2438 6.07745C15.0875 6.23373 14.9997 6.44569 14.9997 6.66671V15.9925C14.9758 16.4139 14.7863 16.8088 14.4726 17.0912C14.1589 17.3736 13.7463 17.5205 13.3247 17.5H6.67467C6.25309 17.5205 5.84049 17.3736 5.52676 17.0912C5.21303 16.8088 5.02358 16.4139 4.99967 15.9925V6.66671C4.99967 6.44569 4.91188 6.23373 4.7556 6.07745C4.59932 5.92117 4.38735 5.83337 4.16634 5.83337C3.94533 5.83337 3.73337 5.92117 3.57709 6.07745C3.42081 6.23373 3.33301 6.44569 3.33301 6.66671V15.9925C3.35679 16.8561 3.72183 17.675 4.34816 18.2699C4.97449 18.8648 5.81107 19.1873 6.67467 19.1667H13.3247C14.1883 19.1873 15.0249 18.8648 15.6512 18.2699C16.2775 17.675 16.6426 16.8561 16.6663 15.9925V6.66671C16.6663 6.44569 16.5785 6.23373 16.4223 6.07745C16.266 5.92117 16.054 5.83337 15.833 5.83337Z"
                      fill="#FEAC7A"
                    />
                    <path
                      d="M16.6667 3.33337H13.3333V1.66671C13.3333 1.44569 13.2455 1.23373 13.0893 1.07745C12.933 0.921171 12.721 0.833374 12.5 0.833374H7.5C7.27899 0.833374 7.06702 0.921171 6.91074 1.07745C6.75446 1.23373 6.66667 1.44569 6.66667 1.66671V3.33337H3.33333C3.11232 3.33337 2.90036 3.42117 2.74408 3.57745C2.5878 3.73373 2.5 3.94569 2.5 4.16671C2.5 4.38772 2.5878 4.59968 2.74408 4.75596C2.90036 4.91224 3.11232 5.00004 3.33333 5.00004H16.6667C16.8877 5.00004 17.0996 4.91224 17.2559 4.75596C17.4122 4.59968 17.5 4.38772 17.5 4.16671C17.5 3.94569 17.4122 3.73373 17.2559 3.57745C17.0996 3.42117 16.8877 3.33337 16.6667 3.33337ZM8.33333 3.33337V2.50004H11.6667V3.33337H8.33333Z"
                      fill="#FEAC7A"
                    />
                    <path
                      d="M9.16667 14.1667V8.33333C9.16667 8.11232 9.07887 7.90036 8.92259 7.74408C8.76631 7.5878 8.55435 7.5 8.33333 7.5C8.11232 7.5 7.90036 7.5878 7.74408 7.74408C7.5878 7.90036 7.5 8.11232 7.5 8.33333V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667Z"
                      fill="#FEAC7A"
                    />
                    <path
                      d="M12.4997 14.1667V8.33333C12.4997 8.11232 12.4119 7.90036 12.2556 7.74408C12.0993 7.5878 11.8874 7.5 11.6663 7.5C11.4453 7.5 11.2334 7.5878 11.0771 7.74408C10.9208 7.90036 10.833 8.11232 10.833 8.33333V14.1667C10.833 14.3877 10.9208 14.5996 11.0771 14.7559C11.2334 14.9122 11.4453 15 11.6663 15C11.8874 15 12.0993 14.9122 12.2556 14.7559C12.4119 14.5996 12.4997 14.3877 12.4997 14.1667Z"
                      fill="#FEAC7A"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
          <div className="add-ons">
            {product?.added?.length > 0 && (
              <div className="add">
                <div>
                  <span>{t("added")}:</span>
                </div>
                {product.added.map((add) => {
                  return (
                    <div>
                      <p>
                        {add?.name
                          ? `${add?.name} (+${add?.price} ${t("lv")})`
                          : ""}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
            {product?.removed?.length > 0 && (
              <div className="without">
                <p>
                  <span>{t("without")}:</span>
                </p>
                {product.removed.map((remove) => {
                  return (
                    <div>
                      <p>{remove?.name ? `${remove?.name}` : ""}</p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="right">
        <div className="first-line">
          <div className="single-price">
            <p>
              {Number(
                product?.singlePrice ? product?.singlePrice : product?.price,
              ).toFixed(2)}
              €/
              {priceBGN !== null ? priceBGN + `${t("lv")}` : "Converting..."}
            </p>
          </div>
          <div className="set-amount">
            <button
              className="minus"
              onClick={() => {
                if (amount !== 1) {
                  setCart((prevCart) => {
                    return prevCart.map((item) => {
                      if (cartItemKey(item) === cartItemKey(product)) {
                        return { ...item, amount: amount - 1 };
                      }
                      return item;
                    });
                  });
                  setAmount(Number(amount) - 1);
                  setAmountExpression("-");
                }
              }}
            ></button>
            <div className="amount">
              <p>{amount}</p>
            </div>
            <button
              className="plus"
              onClick={() => {
                setCart((prevCart) => {
                  return prevCart.map((item) => {
                    if (cartItemKey(item) === cartItemKey(product)) {
                      return { ...item, amount: amount + 1 };
                    }
                    return item;
                  });
                });
                setAmount(Number(amount) + 1);
                setAmountExpression("+");
              }}
            ></button>
          </div>
          <div className="final-price">
            <p>
              {(amount * product?.price)?.toFixed(2)}€/
              {priceBGN !== null
                ? (amount * priceBGN)?.toFixed(2) + t("lv")
                : "Converting..."}
            </p>
          </div>
        </div>
        {window.screen.width > 767 && (
          <div className="second-line">
            {!user?.isGuest && (
              <div
                className="option"
                onClick={() => {
                  addToFavourites(product.id, cookie.access_token).then(() =>
                    setShowMessage(true),
                  );
                }}
              >
                <div className="text">
                  <p>{t("add-to-favourites")}</p>
                </div>
                <div className="icon">
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 19.5135C10.8887 19.5135 10.7775 19.4848 10.6778 19.4272C10.5695 19.3647 7.99692 17.8711 5.38744 15.6204C3.84082 14.2866 2.60625 12.9636 1.71808 11.6883C0.568758 10.038 -0.00921316 8.45065 0.000111035 6.97025C0.0110251 5.24764 0.628012 3.62763 1.73755 2.40861C2.86582 1.16905 4.37153 0.48645 5.9774 0.48645C8.03547 0.48645 9.91711 1.6393 11 3.46555C12.083 1.63934 13.9646 0.48645 16.0227 0.48645C17.5398 0.48645 18.9873 1.10236 20.0987 2.22075C21.3183 3.44807 22.0112 5.18219 21.9999 6.97841C21.9905 8.45623 21.4017 10.0412 20.2499 11.6892C19.359 12.9638 18.1261 14.2862 16.5855 15.6197C13.9856 17.8701 11.4315 19.3637 11.324 19.4262C11.2239 19.4844 11.1119 19.5135 11 19.5135Z"
                      fill="#FEAC7A"
                    />
                  </svg>
                </div>
              </div>
            )}
            <div
              className="option"
              onClick={() => {
                setCart(
                  cart.filter(
                    (item) => cartItemKey(item) !== cartItemKey(product),
                  ),
                );
                window.location.reload();
              }}
            >
              <div className="text">
                <p>{t("remove")}</p>
              </div>
              <div className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.833 5.83337C15.612 5.83337 15.4 5.92117 15.2438 6.07745C15.0875 6.23373 14.9997 6.44569 14.9997 6.66671V15.9925C14.9758 16.4139 14.7863 16.8088 14.4726 17.0912C14.1589 17.3736 13.7463 17.5205 13.3247 17.5H6.67467C6.25309 17.5205 5.84049 17.3736 5.52676 17.0912C5.21303 16.8088 5.02358 16.4139 4.99967 15.9925V6.66671C4.99967 6.44569 4.91188 6.23373 4.7556 6.07745C4.59932 5.92117 4.38735 5.83337 4.16634 5.83337C3.94533 5.83337 3.73337 5.92117 3.57709 6.07745C3.42081 6.23373 3.33301 6.44569 3.33301 6.66671V15.9925C3.35679 16.8561 3.72183 17.675 4.34816 18.2699C4.97449 18.8648 5.81107 19.1873 6.67467 19.1667H13.3247C14.1883 19.1873 15.0249 18.8648 15.6512 18.2699C16.2775 17.675 16.6426 16.8561 16.6663 15.9925V6.66671C16.6663 6.44569 16.5785 6.23373 16.4223 6.07745C16.266 5.92117 16.054 5.83337 15.833 5.83337Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M16.6667 3.33337H13.3333V1.66671C13.3333 1.44569 13.2455 1.23373 13.0893 1.07745C12.933 0.921171 12.721 0.833374 12.5 0.833374H7.5C7.27899 0.833374 7.06702 0.921171 6.91074 1.07745C6.75446 1.23373 6.66667 1.44569 6.66667 1.66671V3.33337H3.33333C3.11232 3.33337 2.90036 3.42117 2.74408 3.57745C2.5878 3.73373 2.5 3.94569 2.5 4.16671C2.5 4.38772 2.5878 4.59968 2.74408 4.75596C2.90036 4.91224 3.11232 5.00004 3.33333 5.00004H16.6667C16.8877 5.00004 17.0996 4.91224 17.2559 4.75596C17.4122 4.59968 17.5 4.38772 17.5 4.16671C17.5 3.94569 17.4122 3.73373 17.2559 3.57745C17.0996 3.42117 16.8877 3.33337 16.6667 3.33337ZM8.33333 3.33337V2.50004H11.6667V3.33337H8.33333Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M9.16667 14.1667V8.33333C9.16667 8.11232 9.07887 7.90036 8.92259 7.74408C8.76631 7.5878 8.55435 7.5 8.33333 7.5C8.11232 7.5 7.90036 7.5878 7.74408 7.74408C7.5878 7.90036 7.5 8.11232 7.5 8.33333V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M12.4997 14.1667V8.33333C12.4997 8.11232 12.4119 7.90036 12.2556 7.74408C12.0993 7.5878 11.8874 7.5 11.6663 7.5C11.4453 7.5 11.2334 7.5878 11.0771 7.74408C10.9208 7.90036 10.833 8.11232 10.833 8.33333V14.1667C10.833 14.3877 10.9208 14.5996 11.0771 14.7559C11.2334 14.9122 11.4453 15 11.6663 15C11.8874 15 12.0993 14.9122 12.2556 14.7559C12.4119 14.5996 12.4997 14.3877 12.4997 14.1667Z"
                    fill="#FEAC7A"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
